import { useContext, useEffect, useState } from "react";
import FullScreenCard from "../../shared/FullScreenCard";
import { fetchBody } from '../../../utils/fetch';
import { transformDate } from '../../../utils/date';
import GeneralContext from "../../../context/GeneralContext";
import TableRequest from "../../TableRequest";

function UserHistory() {

    const { changeCurrentMenu, userHistoryId } = useContext(GeneralContext);

    const [historyList, setHistoryList] = useState([]);

    const prepareList = (list) => {
        const newList = [];
        for (let i = 0; i < list.length; i++) {
            if (list[i].status !== 'pending') {
                list[i].request_date = transformDate(list[i].request_date);
                list[i].status_change_date = transformDate(list[i].status_change_date);
                newList.push(list[i]);
            }
        }
        return newList;
    }

    useEffect(() => {
        const getRequestsFunction = async () => {
            const fetchData = {
                id: userHistoryId
            }
            const response = await fetchBody('requests/list-user-request' , 'POST', fetchData);
            if (response.success) {
                const processedList = prepareList(response.list);
                setHistoryList(processedList);
            }
        }
        getRequestsFunction();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  return (
    <FullScreenCard hasBackNavigation={true} backNavigationFunction={changeCurrentMenu} backNavigationTarget={'requests-history-users'}>
        <h1>Historial del usuario</h1>
        {historyList.map((item) => (
            <div key={item.id}>
            <br />
            <TableRequest data={item} />
            <hr />
            </div>
        ))}
        <br />
    </FullScreenCard>
  )
}

export default UserHistory